export const updateData = (oldData, newData) => {
  const updated = { ...oldData };
  for (const key in newData) {
    updated[key] = newData[key];
  }
  return updated;
};
